/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rental_Checkout_LabelInputs */

const en_rental_checkout_label = /** @type {(inputs: Rental_Checkout_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-Out`)
};

const es_rental_checkout_label = /** @type {(inputs: Rental_Checkout_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-Out`)
};

const fr_rental_checkout_label = /** @type {(inputs: Rental_Checkout_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Départ`)
};

const de_rental_checkout_label = /** @type {(inputs: Rental_Checkout_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-out`)
};

const id_rental_checkout_label = /** @type {(inputs: Rental_Checkout_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-Out`)
};

/** @type {(inputs: Rental_Checkout_LabelInputs) => LocalizedString} */
const ja_rental_checkout_label = en_rental_checkout_label;

/** @type {(inputs: Rental_Checkout_LabelInputs) => LocalizedString} */
const zh_rental_checkout_label = en_rental_checkout_label;

/** @type {(inputs: Rental_Checkout_LabelInputs) => LocalizedString} */
const ar_rental_checkout_label = en_rental_checkout_label;

/** @type {(inputs: Rental_Checkout_LabelInputs) => LocalizedString} */
const it_rental_checkout_label = en_rental_checkout_label;

/** @type {(inputs: Rental_Checkout_LabelInputs) => LocalizedString} */
const ru_rental_checkout_label = en_rental_checkout_label;

/** @type {(inputs: Rental_Checkout_LabelInputs) => LocalizedString} */
const pt_rental_checkout_label = en_rental_checkout_label;

/** @type {(inputs: Rental_Checkout_LabelInputs) => LocalizedString} */
const ko_rental_checkout_label = en_rental_checkout_label;

/**
* | output |
* | --- |
* | "Check-Out" |
*
* @param {Rental_Checkout_LabelInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_checkout_label = /** @type {((inputs?: Rental_Checkout_LabelInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_Checkout_LabelInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_checkout_label(inputs)
	if (locale === "es") return es_rental_checkout_label(inputs)
	if (locale === "fr") return fr_rental_checkout_label(inputs)
	if (locale === "de") return de_rental_checkout_label(inputs)
	if (locale === "ja") return ja_rental_checkout_label(inputs)
	if (locale === "zh") return zh_rental_checkout_label(inputs)
	if (locale === "ar") return ar_rental_checkout_label(inputs)
	if (locale === "id") return id_rental_checkout_label(inputs)
	if (locale === "it") return it_rental_checkout_label(inputs)
	if (locale === "ru") return ru_rental_checkout_label(inputs)
	if (locale === "pt") return pt_rental_checkout_label(inputs)
	return ko_rental_checkout_label(inputs)
});